module.exports = __webpack_public_path__ + "img/ellipse_review.229aa35d.svg";